<template>
    <div>
        <div class="title-box">
            臭氧浓度明细查询
        </div>
        <!-- 查询条件 -->
        <el-form id="formID" :inline="true" :model="queryParams" style="border-radius:3px;margin-bottom:10px; box-shadow:0px 1px 0px 0px rgba(0, 0, 0, 0.1);" class="demo-form-inline">
            <el-row>
                <el-form-item>
                    <el-select ref="factorySelect" v-model="queryParams.factoryId" filterable placeholder="选择工厂" clearable @change="getWorkshopByFactory">
                        <el-option
                        v-for="item in factoryOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select ref="workshopSelect" v-model="queryParams.workshopId" filterable clearable placeholder="选择车间" @change="getSceneByWorkshop">
                        <el-option
                        v-for="item in workshopOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select ref="sceneSelect" placeholder="选择场景" v-model="queryParams.sceneId" clearable filterable @change="getNumByScene">
                        <el-option
                        v-for="item in sceneOptions"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id">
                        </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-select v-model="queryParams.devNum" placeholder="设备编号" clearable filterable>
                    <el-option v-for="dNum in deviceNumList" :key="dNum.id" :label="dNum.name" :value="dNum.name" />
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="queryParams.startTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="开始时间" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-date-picker v-model="queryParams.endTime" type="datetime" value-format="yyyy-MM-dd HH:mm:ss" placeholder="结束时间" clearable></el-date-picker>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="onSubmit">查询</el-button>
                </el-form-item>
                <el-form-item>
                    <el-button type="info" @click="onReset">重置</el-button>
                </el-form-item>
                <!-- 表格/图表切换 -->
                <el-form-item style="float:right;">
                    <span @click="changeData(1)" :class="['tool-icon',{'select-icon': showTable}]" title="表格">
                        <img src="@/assets/images/table.png"/>
                    </span>
                    <span @click="changeData(2)" :class="['tool-icon',{'select-icon': !showTable}]" title="图表">
                        <img src="@/assets/images/chart.png"/>
                    </span>
                    <span v-hasPermi="['enterpr:ozone:export']" title="导出" @click="exportData()" class="tool-icon">
                        <img src="@/assets/images/download.png"/>
                    </span>
                </el-form-item>
            </el-row>
        </el-form>
        <div v-show="showTable">
            <!-- 表格 -->
            <el-table :data="tableData" border :style="{ height: tableHeight + 'px',width:'100%','border-radius':'3px'}" class="custom-table-header">
                <el-table-column type="index" label="序号" width="100" align="center"></el-table-column>
                <el-table-column prop="factoryName" label="工厂" align="center"></el-table-column>
                <el-table-column prop="workshopName" label="车间" align="center"></el-table-column>
                <el-table-column prop="sceneName" label="场景" align="center"></el-table-column>
                <el-table-column prop="sourceTime" label="时间" align="center"></el-table-column>
                <el-table-column prop="o3Ppm" label="臭氧浓度(PPM)" width="120" align="center"></el-table-column>
                <el-table-column prop="supplierName" label="消杀标准浓度(PPM)" width="130" align="center"></el-table-column>
                <el-table-column prop="department" label="浓度偏差(PPM)" align="center"></el-table-column>
            </el-table>

            <!-- 分页 -->
            <div class="block" style="background:#fff;text-align:center;padding:20px 0;">
                <el-pagination
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="queryParams.pageNum"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="queryParams.pageSize"
                    background
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="total">
                </el-pagination>
            </div>
        </div>
        <div v-show="!showTable">
            <div id="lineDiv" :style="{ height: (tableHeight) + 'px',width:'100%','border-radius':'3px',background:'#fff'}"></div>
        </div>
    </div>
</template>
<script>
import { formatDate, formatDateTime, compareDates, isWithinOneMonth } from '@/utils/base';
import * as echarts from 'echarts';
import { Message } from 'element-ui';
import {download} from '@/utils/request';
export default {
    data(){
        return{
            // 查询条件
            queryParams: {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopId:"",
                sceneId:"",
                devNum:"",
                startTime:"",
                endTime:""
            },
            showTable:true,
            //工厂数据
            factoryOptions: [],
            // 车间数据
            workshopOptions:[],
            sceneOptions:[],
            deviceNumList:[],
            total:0,
            tableHeight:650,
            // 表格数据
            tableData:[],
            lineChart:null,
            sourceTime:[],
            lineData:[],
            alarmThreshold:null
        }
    },
    mounted() {
        this.handleResize();
        window.addEventListener('resize', this.handleResize);
        let eDate = formatDateTime(new Date());
        let sDate = formatDate(new Date());
        this.queryParams.endTime = eDate;
        this.queryParams.startTime = sDate+" 00:00:00";
        this.getFactoryByCustomer();
    },
    methods: {
        // 监听窗口缩放
        handleResize(){
            // 当窗口大小变化时，这个函数会被调用
            const height = window.innerHeight;
            // 你可以在这里添加你的处理代码
            let dom = document.getElementById("formID");
            let formH = 70;//一行时高度为70
            if(dom){
                formH = dom.offsetHeight;
            }
            this.tableHeight = height-191-formH;//表单的高度会变化

            // 设置表格体高度
            let tableBody = document.getElementsByClassName("el-table__body-wrapper")[0];
            if(tableBody){
                tableBody.style.height = (this.tableHeight-40)+"px";
            }

            if(this.lineChart){
                this.lineChart.resize();
            }
        },
        // 查询
        onSubmit() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        // 重置
        onReset(){
            let eDate = formatDateTime(new Date());
            let sDate = formatDate(new Date());
            this.queryParams = {
                pageNum:1,
                pageSize: 10,
                factoryId:"",
                workshopId:"",
                sceneId:"",
                devNum:"",
                startTime:sDate+" 00:00:00",
                endTime:eDate
            };
            this.tableData = [];
            this.sourceTime = [];
            this.lineData = [];
            this.alarmThreshold = null;
        },
        handleSizeChange(val) {
            this.queryParams.pageSize = val;
            this.getList();
        },
        handleCurrentChange(val) {
            this.queryParams.pageNum = val;
            this.getList();
        },
        // 根据客户查询工厂
        getFactoryByCustomer(){
            this.$store.dispatch("workshop/getFactoryByCustomer").then((result)=>{
                this.factoryOptions = result.data;
            });
        },
        // 根据工厂查询车间
        getWorkshopByFactory(val){
            if(!val){
                this.queryParams.workshopId = null;
                this.workshopOptions = [];
                this.queryParams.sceneId = null;
                this.sceneOptions = [];
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("scene/getWorkshopByFactory",{factoryId:this.queryParams.factoryId}).then((result)=>{
                this.queryParams.workshopId = null;
                if(result&& result.data&& result.data.length>0){
                    this.workshopOptions = result.data;
                }
                else{
                    this.workshopOptions = [];
                }
            });
        },
        // 根据车间查询场景
        getSceneByWorkshop(val){
            if(!val){
                this.queryParams.sceneId = null;
                this.sceneOptions = [];
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("monitorData/getSceneByWorkshop",{workshopId:this.queryParams.workshopId}).then((result)=>{
                this.queryParams.sceneId = null;
                if(result&& result.data&& result.data.length>0){
                    this.sceneOptions = result.data;
                }
                else{
                    this.sceneOptions = [];
                }
            });
        },
        // 根据场景查询设备编码
        getNumByScene(val){
            if(!val){
                this.queryParams.devNum = null;
                this.deviceNumList = [];
                return;
            }
            this.$store.dispatch("monitorData/getDeviceByScene",{sceneId:this.queryParams.sceneId,deviceName:'臭氧检测器'}).then((result)=>{
                this.queryParams.devNum = null;
                if(result&& result.data&& result.data.length>0){
                    this.deviceNumList = result.data;
                }
                else{
                    this.deviceNumList = [];
                }
            });
        },
        getList(){
            if(compareDates(this.queryParams.startTime,this.queryParams.endTime)){
                Message.warning('截止日期不能早于开始日期！');
                return;
            }
            if(isWithinOneMonth(new Date(this.queryParams.startTime), new Date(this.queryParams.endTime), 31)){
                Message.warning('日期范围不能超过31天！');
                return;
            }
            if(!this.queryParams.devNum){
                Message.warning('请先选择设备编号！');
                return;
            }
            let factoryName = this.$refs.factorySelect.selected.label;
            let workshopName = this.$refs.workshopSelect.selected.label;
            let sceneName = this.$refs.sceneSelect.selected.label;
            if(this.showTable){//表格
                this.$store.dispatch('monitorData/getO3ppmHistoryPage', this.queryParams).then((result)=>{
                    if(result?.rows){
                        this.tableData = result.rows;
                        this.total = result.total;
                        for(let i=0;i<this.tableData.length;i++){
                            this.tableData[i].factoryName = factoryName;
                            this.tableData[i].workshopName = workshopName;
                            this.tableData[i].sceneName = sceneName;
                        }
                    }
                    else{
                        this.tableData = [];
                        this.total = 0;
                    }
                }); 
            }
            else{
                this.$store.dispatch('monitorData/getO3ppmHistory', this.queryParams).then((result)=>{
                    if(result?.data?.values){
                        let values = result?.data?.values;
                        this.alarmThreshold = Number(result?.data?.alarmThreshold);
                        this.sourceTime = [];
                        this.lineData = [];
                         for(let i=values.length-1;i>=0;i--){
                            this.sourceTime.push(values[i].sourceTime);
                            this.lineData.push(values[i].o3Ppm);
                        }
                    }
                    else{
                        this.sourceTime = [];
                        this.lineData = [];
                        this.alarmThreshold = null;
                    }
                    this.initLine();
                }); 
            }
        },
        initLine(){
            var chartDom = document.getElementById('lineDiv');
            this.lineChart = echarts.init(chartDom);
            var option = {
                color:["#01EC92"],
                tooltip : {
                    trigger: 'axis'
                },
                legend: {
                    left: "170",
                    top:"28",
                    data:['臭氧浓度']
                },
                grid:{
                    left:60
                },
                xAxis : [
                    {
                        type : 'category',
                        boundaryGap : false,
                        splitLine: {
                            show: true
                        },
                        axisLine: {
                            lineStyle:{
                                color:"#BFBFBF"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel : {
                            color:"#666666"
                        },
                        data : this.sourceTime
                    }
                ],
                yAxis : [
                    {
                        name:"PPM",
                        nameTextStyle: {
                            color: "#666666"
                        },
                        type : 'value',
                        axisLine: {
                            show: true,
                            lineStyle:{
                                color:"#BFBFBF"
                            }
                        },
                        axisTick: {
                            show: false
                        },
                        axisLabel : {
                            color:"#666666"
                        }
                    }
                ],
                visualMap: {
                    show:false,
                    pieces: [
                        {
                            gt:-1,
                            lte: this.alarmThreshold,
                            color: '#01EC92'
                        },
                        {
                            gt: this.alarmThreshold,
                            color: '#f00'
                        }
                    ]
                },
                series : [
                    {
                        name:'臭氧浓度',
                        type:'line',
                        data:this.lineData,
                         markLine: {
                            silent: true,
                            lineStyle: {
                                color: '#00f'
                            },
                            data: [
                                {
                                    yAxis: this.alarmThreshold
                                }
                            ]
                        }
                    }
                ]
            };
            option && this.lineChart.setOption(option);      
        },
        // 表格/曲线切换
        changeData(data){
            if(data == 2){//曲线
                this.showTable = false;
            }
            else{
                this.showTable = true;
                this.lineChart = null;
            }
            this.getList();
        },
        // 导出
        exportData(){
            download('/biz/o3ppmHistory/export',
            {
                devNum: this.queryParams.devNum,
                startTime: this.queryParams.startTime,
                endTime: this.queryParams.endTime
            },
            `臭氧浓度查询_${new Date().getTime()}.xlsx`)
        }
    }
}
</script>

<style lang="scss" scoped>
    .title-box{
        width: 100%;
        font-size: 16px;
        font-weight: bold;
        padding: 27px 0 15px;
        line-height: 16px;
    }
    // 表头背景色
    ::v-deep .custom-table-header th{
        background-color: #ebeef5 !important;
    }
    // 表格字体大小
    .el-table {
        font-size: 12px;
    }
    // 表单底部边界线
    .el-table::before {
        height: 0px;
    }
    // 表格字体
    ::v-deep .el-table thead {
        color: #606266;
    }
    // 表格内边距
    ::v-deep .el-table .el-table__cell {
        padding: 8px 0;
    }
    // 表单底部margin
    .el-form-item {
        margin-bottom: 0;
    }
    // 当前页码样式
    ::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
        background-color: #FF9F07;
    }
    // 页面hover样式
    .el-pagination.is-background .el-pager li:not(.disabled):hover {
        color: #FF9F07;
    }
    // .el-button{
    //     font-size: 12px;
    // }
    ::v-deep .el-form-item__label {
        font-size: 12px;
    }
    ::v-deep .el-table__body-wrapper{
        height: 100%;
        overflow-y: auto;
    }
    .tool-icon{
        width:28px;
        height:32px;
        cursor:pointer;
        background:#C7C7C7;
        display:inline-block;
        vertical-align:middle;
        text-align:center;
        border-radius:4px;
        margin-left:5px;
    }
    .select-icon{
        background:#3083FB;
    }
</style>